import React, { useState } from 'react'
import { Modal as RModal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useTranslation } from "react-i18next";
import './Categories.css'
import { useDispatch, useSelector } from "react-redux";
import { postCategory } from '../../Redux/Actions/ActionCategories';

function AddCategory({ open, setOpen }) {
    let dispatch = useDispatch();
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [name, setname] = useState('');
    const [name_ar, setname_ar] = useState('');
    const [description, setdescription] = useState('');
    const [description_ar, setdescription_ar] = useState('');
    const [image, setimage] = useState('');
    const [thumbnail, setthumbnail] = useState('');
    const [color, setcolor] = useState('');
    const [loadBtn, setloabBtn] = useState(false);

    const FunSubmit = (e) => {
        e.preventDefault()
        /*console.log(name);
        console.log(name_ar);
        console.log(description);
        console.log(description_ar);
        console.log(image);
        console.log(thumbnail);
        console.log(color);*/
        dispatch(postCategory(name,name_ar,description,description_ar,image,thumbnail,color,setloabBtn))
    }
    return (
        <RModal
            open={open}
            onClose={() => {
                setOpen(false);
            }}
            center={false}
            classNames={{
                modal: "popAdd",
            }}
            focusTrapped={false}
        >
            <div className='popAddForm' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                <h3 className={langLocal == 'ar' ? "textAlignRight" : ""}>{t('addCategory')}</h3>
                <form>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_en')}</span>
                            </div>
                            <input type="text" placeholder={t('name_en')} onChange={(e)=> setname(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('name_ar')}</span>
                            </div>
                            <input type="text" placeholder={t('name_ar')} onChange={(e)=> setname_ar(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_en')}</span>
                            </div>
                            <textarea type="text" placeholder={t('desc_en')} onChange={(e)=> setdescription(e.target.value)} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-pencil' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('desc_ar')}</span>
                            </div>
                            <textarea type="text" placeholder={t('desc_ar')} onChange={(e)=> setdescription_ar(e.target.value)} />
                        </div>
                    </div>
                    <div className='input_row' >
                        <div className='one_input_row'>
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('image')}</span>
                            </div>
                            <input type="File" onChange={(e)=> setimage(e.target.files[0])} />
                        </div>
                        <div className='one_input_row' >
                            <div className='Gen_icon'>
                                <i className='fa fa-image' ></i>
                                <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('thumbnail')}</span>
                            </div>
                            <input type="file" onChange={(e)=> setthumbnail(e.target.files[0])} />
                        </div>
                    </div>
                    <div className='input_no_row' >
                        <div className='Gen_icon'>
                            <i className='fa fa-circle' ></i>
                            <span className={langLocal == 'ar' ? "textAlignRight" : ""} >{t('color')}</span>
                        </div>
                        <input type="color" onChange={(e)=> setcolor(e.target.value)} />
                    </div>
                </form>
                <div className='div_btn' ><button onClick={FunSubmit}  >
                    {
                        loadBtn ? "Loading ... ":<>{t('addCategory')}</>
                    }
                </button></div>
            </div>
        </RModal>
    )
}

export default AddCategory